import * as React from "react";
import type { IconName } from "../../icons";
import { icons } from "../../icons";
import styles from "./IconButton.css";

const sizeMapIcon = {
  small: "1rem",
  medium: "1.25rem",
  large: "1.5rem",
} as const;

type Size = keyof typeof sizeMapIcon;
type Color = "neutral" | "accent" | "success" | "error";
type Variant = "primary" | "secondary" | "tertiary";

interface IconButtonProps {
  icon: IconName;
  ariaLabel: string;
  size?: Size;
  color?: Color;
  variant?: Variant;
  disabled?: boolean;
  type?: "button" | "submit";
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

const IconButton = ({
  icon,
  ariaLabel,
  size = "medium",
  color = "neutral",
  variant = "primary",
  disabled,
  type = "button",
  onClick,
}: IconButtonProps) => {
  const Icon = icons[icon];

  return (
    <button
      aria-label={ariaLabel}
      disabled={disabled}
      type={type}
      onClick={onClick}
      className={styles.iconButton({ size, color, variant })}
    >
      <Icon size={sizeMapIcon[size]} />
    </button>
  );
};

export default IconButton;
